/*
 * Returns a boolean if the string matches the email regex
 * @param {String} the email string
 * @return {Boolean} the match
 */
var validEmail = function validEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line max-len

  return re.test(email);
};

export default validEmail;